<template>
  <div class="container">
    <video autoplay controls src="https://jyx.cxstar.cn/profile/video/library.mp4" poster="../../assets/images/360.jpg" type="video/mp4"></video>
  </div>
</template>

<script>
import baseurl from "../../api/baseurl";
export default {
  name: "home",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  video {
    height: 300px;
    width: 300px;
  }
}
</style>
